import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import "./Service.css";
import serviceLogo from "../Imges/logo-2.png"; 
// import Service2 from "../Componet/Service2"; 
import ServicePhases from '../Componet/ServicePhases'  
import Service3 from '../Componet/Service3' 
import Service1 from '../Componet/Service1'


const allServices = [
  { id: 1, title: "OFFSET PRINTING", description: "Leaflet, Brochures, Catalogue, Stationary Printing" },
  { id: 2, title: "DIGITAL PRINTING", description: "Leaflet, Brochures, Catalogue, Stationary Printing" },
  { id: 3, title: "CUSTOM DESIGN", description: "Personalized and unique print designs for your brand" },
  { id: 4, title: "LARGE PRINTING", description: "Leaflet, Brochures, Catalogue, Stationary Printing" },
  { id: 5, title: "PACKAGING PRINTING", description: "Leaflet, Brochures, Catalogue, Stationary Printing" },
  { id: 6, title: "PROMOTIONAL PRINTING", description: "T-shirts, mugs, and custom merchandise printing" },
  { id: 7, title: "BUSINESS CARDS", description: "Premium business cards with custom designs" },
  { id: 8, title: "LABEL PRINTING", description: "High-quality labels for branding and packaging" },
  { id: 9, title: "BOOKLET PRINTING", description: "High-resolution booklets for presentations and catalogs" },
];

const Services = () => {
  const [visibleServices, setVisibleServices] = useState(3);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const checkVisibility = () => {
      if (sectionRef.current && !hasAnimated) {
        const rect = sectionRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setHasAnimated(true);
        }
      }
    };

    window.addEventListener("scroll", checkVisibility);
    checkVisibility();

    return () => {
      window.removeEventListener("scroll", checkVisibility);
    };
  }, [hasAnimated]);

  const loadMoreServices = () => {
    setVisibleServices((prev) => Math.min(prev + 3, allServices.length));
  };

  return (
    <>
       
       {/* <Service2 />  */}
    <Service1/>
      <ServicePhases/>
      <Service3 />
    </>
  );
};

export default Services;
